import { soilChargeEngineeringProjectConstants } from "../constants";

const initState = {
  edit: {},
  save: {}
};

export const soilChargeEngineeringProject = (state = initState, action) => {
  switch (action.type) {
    case soilChargeEngineeringProjectConstants.GET_EDITED_REQUEST:
      return {
        ...state,
        edit: {
          loading: true
        }
      };
    case soilChargeEngineeringProjectConstants.GET_EDITED_SUCCESS:
      return {
        ...state,
        edit: {
          loading: false,
          editInfo: action.project,
          error: null
        }
      };
    case soilChargeEngineeringProjectConstants.GET_EDITED_FAILURE:
      return {
        ...state,
        edit: {
          loading: false,
          editInfo: null,
          error: action.error
        }
      };
    case soilChargeEngineeringProjectConstants.RESET_EDITED_SUCCESS:
      return {
        ...state,
        edit: {}
      };
    case soilChargeEngineeringProjectConstants.REFRESH_EDITED_SUCCESS:
      // 初始 refresh
      if (!state.edit.editInfo) {
        return {
          ...state,
          edit: {
            editInfo: {
              ...action.refreshEditInfo
            }
          }
        };
      }

      return {
        ...state,
        edit: {
          ...state.edit,
          editInfo: {
            ...state.edit.editInfo,
            ...action.refreshEditInfo
          }
        }
      };
    case soilChargeEngineeringProjectConstants.SET_EDITED_REQUEST:
      return {
        ...state,
        save: {
          processing: true
        }
      };
    case soilChargeEngineeringProjectConstants.SET_EDITED_SUCCESS:
      return {
        ...state,
        save: {
          processing: false
        }
      };
    case soilChargeEngineeringProjectConstants.SET_EDITED_FAILURE:
      return {
        ...state,
        save: {
          processing: false,
          error: action.error
        }
      };
    default:
      return state;
  }
};
